import React, { useContext, useEffect, useState } from 'react';
import PERMISSION_KEYS from '../../constants/permission-keys';
import Select from '../general-components/Select';
import {
    assignDeptPermission,
    removeDeptPermission,
} from '../../services/apiService';
import styles from './EditUserPage.module.css';
import AuthContext from '../../store/auth-context';
import RIGHTS_KEYS from '../../constants/rights-keys';

interface PermissionSelectorProps {
    userId: string;
    initialPermissions: string[];
    onPermissionsChange?: (permissions: string[]) => void;
}

const PermissionSelector: React.FC<PermissionSelectorProps> = ({
    userId,
    initialPermissions,
    onPermissionsChange,
}) => {
    const context = useContext(AuthContext);
    const [permissions, setPermissions] = useState<string[]>([]);

    const [permLib, setPermLib] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        if (context.orRights([RIGHTS_KEYS.cptReporting])) {
            setPermLib((currentPermLib) => ({
                ...currentPermLib,
                'CPT Analytics': PERMISSION_KEYS.cptAnalytics,
            }));
        }
    }, [context]);

    const getPermKeyFromValue = (value: string) => {
        return Object.keys(permLib).find((key) => permLib[key] === value);
    };

    useEffect(() => {
        if (initialPermissions) {
            setPermissions(initialPermissions);
        }
    }, [initialPermissions]);

    const handlePermissionChange = async (permKey: string) => {
        let newPerms = [...permissions];

        const permValue = permLib[permKey];
        const permExists = newPerms.includes(permValue);

        if (permExists) {
            newPerms = newPerms.filter((x) => x !== permValue);
            await removeDeptPermission(userId, permValue);
        } else {
            const response = await assignDeptPermission(userId, permValue);
            newPerms.push(permValue);
        }

        await context.retrieveContext();
        setPermissions(newPerms);
        onPermissionsChange?.(newPerms);
    };

    return (
        <div>
            <div className={styles.beta}>
                <h4>BETA feature access</h4>
            </div>
            <Select
                defaultChecked={permissions.map((p) => getPermKeyFromValue(p))}
                type="checkbox"
                name="permissions"
                options={Object.keys(permLib)}
                changeSelected={handlePermissionChange}
            />
        </div>
    );
};

export default PermissionSelector;
